import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileText, ExternalLink } from "lucide-react";
import { listProspects, listCampaigns } from "@/lib/chiroApi";

export default function Receipts() {
    const [prospects, setProspects] = useState([]);
    const [campaigns, setCampaigns] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        Promise.all([listProspects({}), listCampaigns()]).then(([p, c]) => {
            setProspects(p.filter((x) => x.safety_reviewed_at));
            setCampaigns(c);
            setLoading(false);
        });
    }, []);

    const cmpName = (id) => campaigns.find((c) => c.id === id)?.name || "—";

    return (
        <div data-testid="receipts-page" className="max-w-5xl">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#7cc93c] mb-2">
                // receipts · safety-reviewed proof artefacts
            </div>
            <h1 className="text-3xl font-bold tracking-tight mb-2">Receipts</h1>
            <p className="text-[#9ca3af] text-sm mb-6 max-w-2xl">
                Every prospect we've drafted outreach for keeps two artefacts on the record: the
                original AI-generated text and the safety-reviewed version actually used. This is
                the master list — open one to see both.
            </p>

            {loading && <div className="font-mono text-[12px] text-[#9ca3af]">Loading…</div>}

            {!loading && prospects.length === 0 && (
                <div
                    className="p-8 border border-dashed border-[#262a2e] text-center text-[#9ca3af] font-mono text-[12px]"
                    data-testid="receipts-empty"
                >
                    No safety-reviewed receipts yet. Generate a draft from a prospect's proof
                    notes to create one.
                </div>
            )}

            {!loading && prospects.length > 0 && (
                <div
                    className="border border-[#262a2e] rounded-[2px] divide-y divide-[#262a2e]"
                    data-testid="receipts-list"
                >
                    {prospects.map((p) => (
                        <div
                            key={p.id}
                            data-testid={`receipt-row-${p.id}`}
                            className="flex items-center gap-3 px-4 py-3 hover:bg-[#0f1113]"
                        >
                            <FileText className="w-4 h-4 text-[#7cc93c] shrink-0" />
                            <div className="flex-1 min-w-0">
                                <div className="font-bold text-[13px] truncate">
                                    {p.practice_name}
                                </div>
                                <div className="font-mono text-[10px] text-[#9ca3af] truncate">
                                    {cmpName(p.campaign_id)} · reviewed{" "}
                                    {new Date(p.safety_reviewed_at).toLocaleString()}
                                </div>
                            </div>
                            <Link
                                to={`/prospects/${p.id}/receipt`}
                                target="_blank"
                                rel="noreferrer"
                                data-testid={`receipt-open-${p.id}`}
                                className="flex items-center gap-1 font-mono text-[10px] uppercase tracking-[0.2em] text-[#9ca3af] hover:text-[#7cc93c]"
                            >
                                Open <ExternalLink className="w-3 h-3" />
                            </Link>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
